import React from 'react';
import { ItemSegment } from './types';

export function formatSegmentTableDate(isoString: string) {
  const data = new Date(isoString);

  const formatador = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  return formatador.format(data).replace(',', '');
}

export function formatDetailChain(list: ItemSegment[]) {
  const limite = 10;
  const newList = list.map((item: ItemSegment) => item.nomeItem);

  if (!Array.isArray(newList)) return '';

  const total = newList.length;
  const display = newList.slice(0, limite).join(', ');
  const rest = total > limite ? total - limite : 0;

  if (rest === 0) {
    return display;
  }

  return React.createElement(React.Fragment, null, display, ' ', React.createElement('strong', null, `e mais ${rest} redes`));
}

export function capitalizeFirstLetter(string: string) {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function hasNameInString(value: string): boolean {
  if (typeof value !== 'string') return false;
  return value.toLowerCase().includes('nome');
}
